import Header from '@/components/Header';
import Hero from '@/components/Hero';
import About from '@/components/About';
import Collection from '@/components/Collection';
import Services from '@/components/Services';
import Trust from '@/components/Trust';
import Testimonials from '@/components/Testimonials';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';

const Home = () => {
  return (
    <div className="relative">
      <Header />
      <Hero />
      <About />
      <Collection />
      <Services />
      <Trust />
      <Testimonials />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
